<mat-toolbar class="sidemenu-toolbar">
  <i class="icon mdi mdi-database-arrow-down"></i>
  <span class="title">Data</span>
</mat-toolbar>

<mat-accordion displayMode="flat" togglePosition="before" class="mat-list-custom">
  <!-- Upload  -->
  <mat-expansion-panel (closed)="clearUpload($event)" #uploadPanel *ngIf="[appPermissions.uploadData ,permissionsActions.edit] | builderPermissions">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Upload
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="container-styling">
      <form [formGroup]="entityDataFeedGroup" #form="ngForm">

        <mat-form-field class="w-100  mb-2 mat-no-hint" appearance="outline">
          <mat-label>Select entity</mat-label>
          <mat-select [errorStateMatcher]="matInputError" searchable [isObjectsList]="true" [displayKey]="'entity_name'" formControlName="entityId" disableRipple
            (selectionChange)="onselectEntity($event)">
            <mat-option *ngFor="let option of entityList" [value]="option.entity_id">
              {{ option.entity_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-accordion displayMode="flat" togglePosition="before" class="mb-2" [multi]="true">
         <!-- Matched Widgets Section -->
         <mat-expansion-panel expanded="true" *ngIf="entityDataFeedGroup.get('entityId')?.valid">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="flex-fill">Expected entity headers</span>
              <mat-chip>{{entityWidgets?.length}}</mat-chip>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if(!fetchingWidgets){
            @if(entityWidgets.length){
              <mat-chip-set>
                <mat-chip *ngFor="let match of entityWidgets" class="matched-chip"  [matTooltip]="match.widgetLabel.length > 35 ? match.widgetLabel : ''">
                  {{ match.widgetLabel | truncate:35 }}
                </mat-chip>
              </mat-chip-set>
            }@else {
              <div class="d-flex justify-content-center">
                No widgets are added in the entity
              </div>
            }
          }@else {
            <div class="d-flex justify-content-center">
              Fetching entity widgets
            </div>
          }
        </mat-expansion-panel>
      </mat-accordion>


        <div class="mb-2 mt-2 w-100"  (dragover)="onDragOver($event)"
        (drop)="onDrop($event)" *ngIf="uploadPanel.expanded">
          <div  class="fw-5">Select file*</div>
          <div class="drop-area" *ngIf="resetFileInput" (click)="fileInput.click()">
            @if(fileName){
                <span [matTooltip]="fileName.length > 20 ? fileName : ''">{{fileName | truncate: 20}}</span>
            }@else {
                Click here to select the .csv or .xls or .xlsx
            }
            <input type="file"  (change)="onFileChange($event,fileInput)" hidden #fileInput accept=".csv, .xls, .xlsx">
          </div>
        </div>

        <mat-accordion displayMode="flat" togglePosition="before" class="mb-2" [multi]="true">
          <!-- Original headers -->
          <mat-expansion-panel *ngIf="headers.length" class="mb-2">
            <mat-expansion-panel-header>
              <mat-panel-title>
               <span class="flex-fill">Uploaded file headers</span>
               <mat-chip>{{headers.length}}</mat-chip>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-set>
              <mat-chip *ngFor="let header of formattedHeaders" class="unmatched-chip">
                {{ header  }}
              </mat-chip>
            </mat-chip-set>
          </mat-expansion-panel>

          <!-- Matched Widgets Section -->
          <mat-expansion-panel expanded="true" *ngIf="matchedWidgets().length" class="mb-2"> 
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="flex-fill">  Matched widgets</span>
                <mat-chip>{{matchedWidgets().length}}</mat-chip>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-set>
              <mat-chip *ngFor="let match of matchedWidgets()" class="matched-chip" matTooltipPosition="above"  [matTooltip]="match.info.length > 35 ? match.info : ''">
                {{ match?.info | truncate:35 }}
              </mat-chip>
            </mat-chip-set>
          </mat-expansion-panel>

          <!-- Unmatched Widgets Section -->
          <mat-expansion-panel *ngIf="unmatchedWidgets().length && fileToUpload && entityDataFeedGroup.get('entityId')?.valid" class="mb-2">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="flex-fill">  Unmatched widgets</span>
                <mat-chip>{{unmatchedWidgets().length}}</mat-chip>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-set>
              <mat-chip *ngFor="let widget of unmatchedWidgets()" class="unmatched-chip">
                {{ widget.widgetLabel | truncate:35}}
              </mat-chip>
            </mat-chip-set>
          </mat-expansion-panel>

          <!-- Unmatched Headers Section -->
          <mat-expansion-panel *ngIf="unmatchedHeaders().length && entityDataFeedGroup.get('entityId')?.valid" class="mb-2">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="flex-fill"> Unmatched headers</span>
                <mat-chip>{{unmatchedHeaders().length}}</mat-chip>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-set>
              <mat-chip *ngFor="let header of unmatchedHeaders()" class="unmatched-header-chip">
                {{ header | truncate:35 }}
              </mat-chip>
            </mat-chip-set>
          </mat-expansion-panel>

        </mat-accordion>

        <mat-form-field class="w-100 mt-2 mb-2 " appearance="outline" *ngIf="matchedWidgets().length" >
          <mat-label>Select primary keys</mat-label>
          <mat-select multiple [errorStateMatcher]="matInputError" searchable [isObjectsList]="true" [displayKey]="'widgetLabel'" formControlName="primaryKeys" disableRipple>
            <mat-option *ngFor="let option of matchedWidgets()" [value]="option">
              {{ option.widgetLabel }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="d-flex flex-column align-items-lg-start mb-3 border-1 border-dark" *ngIf="bulkUploadResponce">
          <div>Added entries: {{ bulkUploadResponce["new_records_created"] }}</div>
          <div>Updated entries: {{ bulkUploadResponce["updated_records"] }}</div>
          <div *ngIf="bulkUploadResponce['failed_records'] > 0">Failed entries: {{ bulkUploadResponce["failed_records"] }}</div>
        </div>
        <div class="d-flex ">
          @if(!bulkUploadInProcess){
            <mat-menu #fileMenu="matMenu">
              <button mat-menu-item (click)="generateFile('csv')">CSV</button>
              <button mat-menu-item (click)="generateFile('xlsx')">Excel (XLSX)</button>
              <button mat-menu-item (click)="generateFile('xls')">Excel (XLS)</button>
            </mat-menu>
            
            <button mat-raised-button color="accent" *ngIf="entityDataFeedGroup.get('entityId')?.valid && entityWidgets?.length > 0"  [matMenuTriggerFor]="fileMenu" >
             <mat-icon>download</mat-icon>Template
            </button>
            <span class="flex-fill"></span>
            <button mat-raised-button color="primary" [disabled]="!(entityDataFeedGroup.valid && fileToUpload && matchedWidgets().length > 0)"
              (click)="uploadBulk()">
             <mat-icon>upload</mat-icon> Upload data
            </button>
          }@else {
            <div class="pe-1">Uploading data</div>   <mat-spinner id="uploadBulkSpinner" diameter="24" color="secoundary"></mat-spinner>
          } 
    
        </div>

      </form>
    </div>
  </mat-expansion-panel>

  <!-- Download  -->
  <mat-expansion-panel *ngIf="[appPermissions.downloadData ,permissionsActions.read] | builderPermissions">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Download
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="container-styling">
      <form [formGroup]="entitySubmissionDetailsForm">
        <mat-form-field class="w-100  m-1" appearance="outline" (click)="onSelectClick()">
          <mat-label>Select entity</mat-label>
          <mat-select [errorStateMatcher]="matInputError" searchable [isObjectsList]="true" [displayKey]="'entity_name'" formControlName="entity_id" disableRipple>
            <mat-option *ngFor="let option of entityList" [value]="option.entity_id">
              {{ option.entity_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="text-danger text-center error-message" *ngIf="showErrorMessage">Please create an Entity first.</div>
        <mat-form-field class="w-100  m-1" appearance="outline">
          <mat-label>Submissions</mat-label>
          <mat-icon matIconSuffix *ngIf="entitySubmissionDetailsForm.get('duration')?.value" (click)="$event.preventDefault();resetSubmissionsfield()">close</mat-icon>
          <mat-select formControlName="duration" disableRipple>
            <mat-option *ngFor="let option of durationsList" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="entitySubmissionDetailsForm.value.duration === 'custom'">
          <mat-form-field class="w-100  m-1" appearance="outline">
            <mat-label>Date From</mat-label>
            <input matInput [matDatepicker]="from" formControlName="fromDate" (focus)="datapopUpControlFrom(from,false)"
              readonly>
            <mat-datepicker-toggle matIconSuffix [for]="from"></mat-datepicker-toggle>
            <mat-datepicker #from (closed)="datapopUpControlFrom(from,true)"></mat-datepicker>
          </mat-form-field>
          <div class="date-error-message"
            *ngIf="entitySubmissionDetailsForm.get('fromDate')?.touched && entitySubmissionDetailsForm.get('fromDate')?.hasError('required') && !entitySubmissionDetailsForm.get('fromDate')?.hasError('matDatepickerParse')">
            Please select a date!
          </div>
          <div class="date-error-message "
            *ngIf="entitySubmissionDetailsForm.get('fromDate')?.touched && entitySubmissionDetailsForm.get('fromDate')?.hasError('matDatepickerParse')">
            Please enter a valid date.
          </div>
          <div class="date-error-message"
            *ngIf="entitySubmissionDetailsForm.get('fromDate')?.touched && entitySubmissionDetailsForm.get('fromDate')?.hasError('dateRangeError')">
            Please select a valid date
          </div>
          <mat-form-field class="w-100  m-1" appearance="outline">
            <mat-label>Date To</mat-label>
            <input matInput [matDatepicker]="to" formControlName="toDate" (focus)="datapopUpControlTo(to,false)"
              readonly>
            <mat-datepicker-toggle matIconSuffix [for]="to"></mat-datepicker-toggle>
            <mat-datepicker #to (closed)="datapopUpControlTo(to,true)"></mat-datepicker>
          </mat-form-field>
          <div class="date-error-message"
            *ngIf="entitySubmissionDetailsForm.get('toDate')?.touched && entitySubmissionDetailsForm.get('toDate')?.hasError('required') && !entitySubmissionDetailsForm.get('toDate')?.hasError('matDatepickerParse')">
            Please select a date!
          </div>
          <div class="date-error-message"
            *ngIf="entitySubmissionDetailsForm.get('toDate')?.touched && entitySubmissionDetailsForm.get('toDate')?.hasError('matDatepickerParse')">
            Please enter a valid date.
          </div>
          <div class="date-error-message"
            *ngIf="entitySubmissionDetailsForm.get('toDate')?.touched && entitySubmissionDetailsForm.get('toDate')?.hasError('dateRangeError')">
            Please enter a valid date
          </div>
        </ng-container>
        <div class="genarated-link">
          <div class="link-text alert alert-danger " *ngIf="noDataAvailable">
            There is no data to download!
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button mat-raised-button color="primary"  (click)="downloadEntitySubmissionData()"
            [disabled]="!entitySubmissionDetailsForm.valid">
            <mat-label>Download Data</mat-label>
          </button>
        </div>
      </form>
    </div>
  </mat-expansion-panel>
  
  <!-- View -->
  <mat-expansion-panel (closed)="clearTable($event)" *ngIf="[appPermissions.viewData ,permissionsActions.read] | builderPermissions">
    <mat-expansion-panel-header>
        <mat-panel-title>View</mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="entityEntriesViewGroup" #form="ngForm">
        <mat-form-field class="w-100  mb-2 mat-no-hint" appearance="outline">
          <mat-label>Select entity</mat-label>
          <mat-select [errorStateMatcher]="matInputError" searchable [isObjectsList]="true" [displayKey]="'entity_name'" formControlName="entityId" disableRipple >
            <mat-option *ngFor="let option of entityList" [value]="option.entity_id">
              {{ option.entity_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
    </form>
        <div class="d-flex justify-content-end">
            <button mat-raised-button color="primary" [disabled]="entityEntriesViewGroup.invalid"
              (click)="viewEntityEntries()"> View data</button>
          </div>
  </mat-expansion-panel>
</mat-accordion>